<!-- eslint-disable no-unused-vars -->
<template>
  <div>
    <Header/>
    <Scroll/>
    <div class="hp_orderCompWrap">
      <div class="hp_orderCompInner">
        <h2 class="hp_orderCompTit">
          결제에 <span class="pointTextBlue">실패</span>하였습니다.
        </h2>
        <div class="hp_orderCompContent">
          <p>실패사유 : {{this.$route.query.error_msg}}</p>
        </div>
        <div class="hp_orderCompBtnBox">
          <button class="hp_orderCompBtnW" @click="goToMain">메인으로</button>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<!-- eslint-disable camelcase -->
<script>
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'

export default {
  name: 'ReservationMobileFail',
  components: {
    Header,
    Footer,
    Scroll
  },
  methods: {
    goToMain () {
      this.$router.push({
        path: '/'
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Order/OrderMobileFail.vue